import { createSlice } from "@reduxjs/toolkit";
import { RequestStatus as Status } from "constants/RequestStatus";
import reducers from "./reducers";
import { FilterRoleState } from "types/FilterRole";

const initialState: FilterRoleState = {
  loading: false,
  role: { name: "", description: "", permission: [], isAdmin: false },
  roleMembersCount: 0,
  roleOptions: [],
  roleCreationStatus: Status.Loading,
  roleRequestStatus: Status.Loading,
  roleOptionsRequestStatus: Status.Loading,
  roleUpdateStatus: Status.Loading,
  roleDeletionStatus: Status.Loading,
  membersUpdateStatus: Status.Loading,
  switchMemberStatus: Status.Loading,
};

export const filterRoleSlice = createSlice({
  name: "filterrole",
  initialState,
  reducers,
});

export const {
  setFilterRole,
  setFilterRoleMembersCount,
  setFilterRoleOptions,
  setFilterRoleCreationStatus,
  setFilterRoleRequestStatus,
  setFilterRoleOptionsRequestStatus,
  setFilterRoleUpdateStatus,
  setFilterRoleDeletionStatus,
  setMembersUpdateStatus,
  setSwitchMemberStatus,
} = filterRoleSlice.actions;

export default filterRoleSlice.reducer;
